<template>
  <div id='index'>
        <div class="maincon">
             <div class="maincon-swipelist">
               <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
                  <van-swipe-item v-for='item in lunbolist' :key='item.id'>
                      <img class="maincon-swipe-img" :src="item.headimg" @click="goPage(item.link)"/>
                  </van-swipe-item>
               </van-swipe>
             </div>
             <div class="maincon-btngroup">
                <div class="maincon-btngroup-con">
                     <div class="maincon-btnitem" @click='goPage("/shoplist")'>
                           <div class="maincon-btnitem-img"><Icon src="yshop" class='iconstyle'/></div>
                           <div class="maincon-btnitem-text">订货</div>
                     </div>
                     <div class="maincon-btnitem" @click="goPage('/fahuo')">
                        <div class="maincon-btnitem-img"><Icon src="yfahuo" class='iconstyle'/></div>
                        <div class="maincon-btnitem-text">发货</div>
                     </div>
                     <div class="maincon-btnitem" >
                        <div class="maincon-btnitem-img" @click="goPage('/myclient')"><Icon src="ygroup" class='iconstyle'/></div>
                        <div class="maincon-btnitem-text">客户管理</div>
                     </div>
                     <div class="maincon-btnitem"  @click='goPage("/orderlist")'>
                        <div class="maincon-btnitem-img"><Icon src="yorder" class='iconstyle'/></div>
                        <div class="maincon-btnitem-text">订单信息</div>
                     </div>
                </div>
             </div>
             <div class="actcon">
                 <div class="actcon-title">活动专区</div>
                 <div class="actcon-list">
                     <div class="actcon-list-item-row" v-for="item in activities" :key="item.id" @click="goPage(item.link)">
                         <div class="actcon-list-item-col"><img :src="item.headimg"/></div>
                         <div class="actcon-list-item-col">{{item.title}}</div>
                     </div>
                 </div>
             </div>
        </div>
  </div>
</template>
<script>
import Icon from "@/components/icon"
import { Swipe,SwipeItem,Popup,Overlay} from 'vant';

export default {
   name: 'index',
   data() {
      return {
         uinfo:{headimg:''},
         showShare:false,
         showTipImg:false,
         lunbolist:[],
         activities:[]
      }
   }, 
   created(){
      this.getList(); 
   },
   methods: {
      getList(){
          this.$post("/index/getIndex",{}).then((data)=>{
            if(!data.result.success){
              this.$toast(data.result.info);return false
            }
            this.uinfo     =data.result.info.uinfo
            this.lunbolist =data.result.info.lunbolist
            this.activities=data.result.info.activities
          })
      },
      goPage(url){
         this.$go(url)
      },
      showTips(){
         this.$toast("暂未开放")  
      }
   },
   components: {
      [Swipe.name]: Swipe,
      [SwipeItem.name]: SwipeItem,
      [Popup.name]: Popup,
      [Overlay.name]: Overlay,
      Icon
   }
}
</script>
<style scoped>
#index{background-color:#F6F6F6;min-height: 100vh;}
.maincon{width:100%;padding: 0 0.2rem;padding-bottom: 60px;}

.maincon-levelup{border-radius: 0.1rem;display: flex;height:1.5rem;padding: 0.1rem;align-items: center;background-color:#F4C68A;}
.maincon-levelup-col1-img{width:1rem;height:1rem;padding: 0.1rem;}
.maincon-levelup-col2{display: flex;flex-flow: column nowrap;margin-left: 0.2rem;}
.maincon-levelup-col2-text1{color:#666;font-size:0.3rem;text-align: left;}
.maincon-levelup-col2-text2{color:#333;font-size: 0.35rem;text-align: left;}
.maincon-levelup-right{padding: 0.2rem;margin-left: auto;font-size: 0.35rem;color:#333;}

.maincon-swipelist{margin-top: 0.2rem;}
.my-swipe{color: #2d2c32;text-align: center;}
.maincon-swipe-img{margin: 0;padding: 0;width:100%;border-radius: 0.1rem;}
.maincon-btngroup{display: flex;flex-flow: column nowrap;margin-top:0.2rem;border-radius: 0.1rem;background-color: #fff;padding: 0.5rem 0;}
.maincon-btngroup-con{display: flex;flex-flow: row nowrap;}
.maincon-btngroup-title{color:#333;padding:0.4rem;text-align: left;font-size: 0.3rem;}
.maincon-btnitem{display: flex;flex-flow: column nowrap;flex:0 0 25%}
.maincon-btnitem-img img{width:1rem;height:1rem;}
.maincon-btnitem-text{color:#333;margin-top: 0.1rem;font-size:0.35rem;}
.actcon{border-radius: 0.1rem;width: 100%;margin-top: 0.25rem;background-color: #fff;}
.actcon-title{color:#333;text-align: left;padding: 0.4rem 0.4rem 0 0.4rem;font-size: 0.3rem;}
.actcon-list{margin-top: 0.05rem}
.actcon-list-item-row{margin-top: 0.1rem;padding: 0.1rem;display: flex;flex-flow: row nowrap;}
.actcon-list-item-col{flex:0 0 50%;padding: 0.2rem;color:#333;text-align: left;font-size:0.35rem;}
.actcon-list-item-col img{border-radius: 0.1rem;height:2.5rem;}
.iconstyle{width:0.9rem;height:0.9rem}

.sharebox{border-top-left-radius: 0.2rem;border-top-right-radius: 0.2rem;display: flex;width:100%;background-color: #fff;flex-flow: column nowrap;}
.btngroup{display: flex;padding-bottom: 0.35rem;height:3rem;align-items: center;}
.btngroup-col{display: flex;flex-flow: column nowrap;flex:0 0 25%;}
.shareicon{padding: 0.58rem;padding-bottom: 0.2rem;}
.shareicon img{width:100%;}
.sharewords{font-size: 0.25rem;color:#333;}
.cancelbtn{background-color: #f0f0f0;color:#999999;font-size: 0.3rem;display: flex;height: 1rem;justify-content: center;align-items: center;}
.sharebarcode{display: flex;position: absolute;width:100%;height: calc( 100vh - 4rem );z-index:9999;align-items: center;justify-content: center;background-color: transparent;left:0;top:0;}
.sharebarcode-img{width:6.5rem;background-color: #fff;border-radius: 0.25rem;display: flex;align-items: center;justify-content: center;flex-flow: column nowrap;padding: 0.6rem;}
.sharetip{padding: 0.15rem;user-select: none;}
.tip-block{display: flex;justify-content: flex-end;width: 100%;}
.tip-block-img{width:320px;height:256px;}
::v-deep .van-overlay {z-index:1000;}
.windowgroup{display: flex;flex-flow: column nowrap;margin-top:0.2rem;}
.part1{width:100%;}
.part2{width:100%;display: flex;flex-flow: row nowrap;}
.part2-left{width:50%;}
.part2-right{width:50%;padding-left: 0.05rem;display: flex;flex-flow: column nowrap;justify-content: space-between;}
</style>